<template>
  <div>
    <a-select
      class="w100"
      v-model:value="innerValue"
      :disabled="disabled"
      :placeholder="placeholder"
      :class="class"
      allow-clear
      option-filter-prop="title"
      @change="onChange"
      @clear="onClear"
    >
      <a-select-option :title="trueText" value="1">{{ trueText }}</a-select-option>
      <a-select-option :title="falseText" value="0">{{ falseText }}</a-select-option>
    </a-select>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";

/**
 * 全局组件: 布尔值选择器
 *
 * 使用方式:
 * <boolean-select v-model="formRef.enable"></boolean-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "BooleanSelect",
  props: {
    value: { type: Boolean, default: undefined },
    placeholder: { type: String, default: "请选择" },
    disabled: { type: Boolean, default: false },
    trueText: { type: String, default: "启用" },
    falseText: { type: String, default: "停用" },
    class: {
      type: String,
      default: "append-to-body",
    },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const innerValue = ref<string | undefined>(undefined);

    const onChange = (code) => {
      if (code === "1") {
        emit("update:value", true);
      }
      if (code === "0") {
        emit("update:value", false);
      }
    };

    const onClear = () => {
      emit("update:value", undefined);
    };

    watch(
      () => props.value,
      (value) => {
        if (value === undefined) {
          innerValue.value = value;
        } else {
          if (value === true) {
            innerValue.value = "1";
          }
          if (value === false) {
            innerValue.value = "0";
          }
        }
      },
      { immediate: true }
    );

    return {
      innerValue,
      onChange,
      onClear,
    };
  },
});
</script>
